export const calculateIntrinsicSize = (size?: number): string | undefined => {
  return size ? `${Math.round(size < 10 ? size * 1000 : size)}px` : undefined;
};
